import ScanErrorHandle from '@/modules/scan-error-handle/routes'
import affairManageRoute from '../affair-manage/routes';

export default {
  path: 'exam-manage',
  component: () => import('./ExamManage.vue'),
  children: [
    {
      path: '',
      redirect: 'overview',
    },
    affairManageRoute,
    ScanErrorHandle,
    {
      path: 'overview',
      name: 'overview',
      component: () => import('./exams-overview/ExamsOverview.vue'),
      meta: {
        keepAlive: true, // 标记该路由组件需要被缓存
        scrollEl: '#exams-overview-main', // 标记该页面中需记录滚动高度的元素
      },
    },
    {
      path: 'paper-question',
      name: 'paperQuestion',
      component: () => import('./exam-process/views/paperQuestion.vue')
    },
    {
      path: 'create-exam',
      name: 'createExam',
      //   component: () => import('./views/CreateExam.vue'),
      // },
      // {
      //   path: 'create-joint-exam',
      //   name: 'CreateJointExam',
      component: () => import('./create-exam/CreateJointExam.vue'),
    },
    {
      path: 'exam-detail/:examId',
      name: 'exam-detail',
      component: () => import('./views/ExamDetail.vue'),
      props: true,
      children: [
        {
          path: '',
          redirect: 'subject-exam',
        },
        {
          path: 'subject-exam',
          component: () => import('./views/SubjectExam.vue'),
        },
        {
          path: 'staff-manage',
          component: () => import('./views/StaffManage.vue'),
        },
        {
          path: 'result-preliminary',
          component: () => import('./views/ResultPreliminary.vue'),
        },
      ],
    },
    {
      path: 'process',
      name: 'examProcess',
      component: () => import('./exam-process/ExamProcess.vue'),
      children: [
        // {
        //   path: '',
        //   redirect: 'total',
        // },
        {
          path: 'total',
          name: 'totalProcess',
          component: () => import('./exam-process/views/TotalProcess.vue'),
          beforeEnter: (to, from, next) => {
            // 从localStorage获取当前用户信息
            const localStoragePrefix = 'examination_single_desktop_';
            const userRole = localStorage.getItem(`${localStoragePrefix}role_name`);
            const examId = localStorage.getItem(`${localStoragePrefix}exam_id`);
            const schoolId = localStorage.getItem(`${localStoragePrefix}exam_school_id`);

            // 检查是否是单校联考
            if (schoolId === '0' && userRole !== '区域管理员' && userRole !== '镇区（街道）管理员' && examId) {
              console.log('路由拦截: 单校联考尝试访问总览页面，重定向到科目页面');

              // 获取考试信息来确定要重定向到哪个科目
              const { Vue } = window;
              if (Vue && Vue.prototype.$serve && Vue.prototype.$serve.getExamProgress) {
                Vue.prototype.$serve.getExamProgress(examId).then(response => {
                  if (response.status === 200 && response.body) {
                    const subjectList = response.body.subject_statuses;
                    if (subjectList && subjectList.length > 0) {
                      // 按状态排序找到状态最高的科目
                      const sortedSubjects = [...subjectList].sort((a, b) => b.status - a.status);
                      const firstSubject = sortedSubjects[0].subject_id;
                      const subjectStatus = subjectList.find(s => s.subject_id === firstSubject);

                      // 检查该科目是否允许访问（避免重定向到已结束的考试）
                      if (subjectStatus && subjectStatus.status >= 4) {
                        // 如果科目已开启阅卷状态，不重定向，允许进入总览页面
                        console.log('科目已开启阅卷状态，允许进入总览页面');
                        next();
                      } else {
                        // 重定向到该科目页面
                        next(`/MainPage/exam-manage/process/subject/${firstSubject}${to.query ? `?${new URLSearchParams(to.query).toString()}` : ''}`);
                      }
                    } else {
                      // 没有科目，允许进入总览页面
                      next();
                    }
                  } else {
                    // API请求失败，允许进入总览页面
                    next();
                  }
                }).catch(() => {
                  // 出错时允许进入总览页面
                  next();
                });
              } else {
                // Vue实例或服务不可用，允许进入总览页面
                next();
              }
            } else {
              // 不是单校联考，正常进入总览页面
              next();
            }
          }
        },
        {
          path: 'subject/:subjectIdStr',
          name: 'subjectProcess',
          component: () => import('./exam-process/views/SubjectView.vue'),
          props: true,
          children: [
            {
              path: '',
              redirect: 'subjectStep',
            },
            {
              path: 'subjectStep',
              name: 'subjectStep',
              // component: () => import('./exam-process/views/SubjectProcess.vue'),
              component: () => import('./exam-process/views/OldSubjectProcess.vue'),
            },
            {
              path: 'alarm/:querySchoolId',
              name: 'alarm',
              props: true,
              component: () => import('./exam-process/views/AlarmInfo.vue'),
            }
          ]
        },
      ],
    },
    {
      path: 'divideBlock/:examId',
      name: 'divideBlock',
      component: () => import('./views/DivideBlock.vue'),
    },
    {
      path: 'score-publish-control',
      name: 'ScorePublishControl',
      component: () => import('./views/ScorePublishControl.vue'),
    },
    // ScanErrorHandle
  ]
};
